module.exports = __webpack_public_path__ + "static/media/area1.6a835467.png";